export const ACCEPTED_IMAGE_EXTENSIONS = ".jpg,.jpeg,.png,.webp";

export const isAllowedImageFile = (file) =>
    !/\.svg$/i.test(file.name) && file.type !== "image/svg+xml";

export const SVG_NOT_ALLOWED_MESSAGE = "No se permiten imágenes SVG.";
